module.exports = __webpack_public_path__ + "media/images/landing/how_we_do_it_end_game-9a4b5c73f1bd48669a968da31e633e09.png";